<template>
  <tbody>
    <!-- No records row -->
    <tr v-if="!rows.records || rows.records.length < 1">
      <td :colspan="colSpan" align="center">No data found.</td>
    </tr>

    <tr v-for="row in rows.records" :key="row.member_id">
      <td>{{ row.gid }}</td>

      <td style="width: 260px; max-width: 260px; white-space: normal;">
        <div class="yellow-section">
          <div class="info-row">
            <strong>Group Code: </strong>
            <span class="info-row">{{ row.gcode }}</span>
          </div>
          <div class="info-row">
            <strong>Name: </strong>
            <span class="member-name">{{ row.gname }}</span>
          </div>
          <div class="info-row">
            <strong>Status: </strong>
            <span :class="row.status + '-status'">
              {{ row.status }}
            </span>
          </div>
          <div class="info-row">
            <strong>Email: </strong>
            <span style="word-break: break-word;">{{ row.gemail || "-" }}</span>
          </div>
          <div class="info-row">
            <strong>Phone: </strong>
            <span>{{ row.gphone || "-" }}</span>
          </div>
        </div>
      </td>

      <td>
        <div class="member-section">
          <div class="info-row">
            <strong>Total: </strong>
            <span class="member-name">{{ row.total_members }}</span>
          </div>
          <div class="info-row">
            <strong>Pending: </strong>
            <span class="member-name">{{
              row.total_pending_members || "-"
            }}</span>
          </div>
          <div class="info-row">
            <strong>Active : </strong>
            <span class="member-name">{{ row.activeCount || "-" }}</span>
          </div>
          <div class="info-row">
            <strong>Termed : </strong>
            <span class="member-name">{{ row.termCount || "-" }}</span>
          </div>
          <div class="info-row">
            <strong>Withdrawn: </strong>
            <span class="member-name">{{ row.withDrawnCount || "-" }}</span>
          </div>
        </div>
      </td>

      <td style="white-space: pre-line; word-break: break-word;">
        {{ (row.plan_name_systems || "-").replace(/, /g, "\n") }}
      </td>

      <td style="width: 200px; max-width: 260px; white-space: normal;">
        <div class="info-row">
          <strong>Renewal Date: </strong>
          <span>{{ row.renewal_date }}</span>
        </div>
        <br />
        <div class="info-row">
          <strong>Effective Date: </strong>
          <span>{{ row.group_effective_date || "-" }}</span>
        </div>
      </td>

      <td style="width: 50px; max-width: 100px; word-break: break-word;">
        <span>
          {{ row.remaining_days }}
        </span>
      </td>

      <td style="width: 260px; max-width: 260px; white-space: normal;">
        <div class="yellow-section">
          <div class="info-row">
            <strong>Rep Code: </strong>
            <span>{{ row.agent_code || "-" }}</span>
          </div>
          <div class="info-row">
            <strong>Name: </strong>
            <span class="rep-name">{{ row.agent_name }}</span>
          </div>
          <div class="info-row">
            <strong>Email: </strong>
            <span style="word-break: break-word;">{{
              row.agent_email || "-"
            }}</span>
          </div>
          <div class="info-row">
            <strong>Phone: </strong>
            <span>{{ row.agent_phone1 || "-" }}</span>
          </div>
        </div>
      </td>
    </tr>
  </tbody>
</template>

<script>
export default {
  name: "PendingGroupRenewalTable",
  props: {
    rows: {
      type: Object,
      required: true,
    },
    colSpan: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.plans {
  display: block;
  margin-bottom: 3px;
}

.pill-red {
  background-color: #028f02;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 5px;
  border-radius: 10px;
  margin-left: 5px;
  display: inline-block;
}

.yellow-section {
  background-color: #d6f8fa;
  padding: 4px 8px;
  border-radius: 6px;
  margin-top: 4px;
  display: inline-block;
  font-size: 12px;
  color: #333;
  line-height: 1.4;
  border: 1px solid #ffeeba;
  width: 100%;
}

.member-section {
  background-color: #cbf1f3;
  padding: 4px 8px;
  border-radius: 6px;
  margin-top: 4px;
  display: inline-block;
  font-size: 12px;
  color: #333;
  line-height: 1.4;
  border: 1px solid #ffeeba;
  width: 100%;
}

.info-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 2px;
}

.member-name {
  font-weight: bold;
  font-size: 14px;
  color: #0275d8;
  margin-left: 4px;
  word-break: break-word;
}

.active-status {
  font-weight: bold;
  font-size: 14px;
  color: #178b24;
  margin-left: 4px;
  word-break: break-word;
}

.termed-status {
  font-weight: bold;
  font-size: 14px;
  color: #ba0808;
  margin-left: 4px;
  word-break: break-word;
}

.inactive-status {
  font-weight: bold;
  font-size: 14px;
  color: #cd9b13;
  margin-left: 4px;
  word-break: break-word;
}

.rep-name {
  font-weight: bold;
  font-size: 14px;
  color: #720ea8;
  margin-left: 4px;
  word-break: break-word;
}

.groups {
  display: block;
  margin-bottom: 3px;
}

th {
  white-space: normal;
  word-break: break-word;
}
</style>
